<template>
  <div>
    <HeaderBreadcrumbs
      :items="[
        { label: 'Author' },
      ]"
      title="All Author"
    />
  <div class="bg-white">
    <div class="flex justify-between py-3 px-4">
      <div class="relative">
                    <svg  class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                    <input class="bg-white rounded-lg py-2 px-11 border w-96"
                        placeholder='Search Author Name, Slug' v-model="author_search" @input="onSearch" />
                    <button v-if="author_search"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>

                </div>
                <button
            class="text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
            type="button">
            <router-link class="text-white px-1 py-2" :to="{ path: 'author/create' }">
              <i class="fa fa-plus"></i> Add New
            </router-link>
          </button>
    </div>
    <Table 
      :headers="headers" 
      :data="items"
      :row-key="['name', 'slug', 'first_name', 'last_name','academic_title','created','modified']" 
      
      :current-page="currentPage"
      :isLoading="isLoading"
      :per-page="100">
        <template #header-create="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
        <template #header-modified="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
        <template #created="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #modified="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <!-- slot actions -->
        <template #actions="{ row }">
          <router-link :to="{ ...AuthorUpdatePath, params: { id: row.id } }"
            class="link text-gray-600 align-middle items-center flex justify-center">
            <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                clip-rule="evenodd" />
            </svg>

          </router-link>
        </template>
      </Table>
      <div v-if="!isLoading && items.length  " class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1">
          <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              @change="onClickPage" />
          </div>
        </div>
     </div>
  </div>
 
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Table from '@/components/form/table.vue'
import { AuthorCreatePath, AuthorUpdatePath } from "../../router/content";

export default {
  name: "Author",
  components: {
    HeaderBreadcrumbs,
    Table
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
      author_search: '',
      typing: false,
      headers: [
        { label: 'No', key: 'no' },
        { label: 'Author Name', key: 'name' },
        { label: 'Slug', key: 'slug' },
        { label: 'first name', key: 'first_name' },
        { label: 'last name', key: 'last_name' },
        { label: 'academic title', key: 'academic_title' },
        { label: 'created Date', key: 'created', sortable: true, slotHeader: 'header-create' },
        { label: 'modified Date', key: 'modified', sortable: true, slotHeader: 'header-modified' },
       
      ],
      AuthorCreatePath,
      AuthorUpdatePath,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.author.isLoading,
      isError: (state) => state.author.isError,
      totalRows: (state) => state.author.totalRows,
      items: (state) => state.author.authors,
    }),
  },
  mounted() {
    this.actionFetchAuthor();
  },
  methods: {
    ...mapActions('author', ['fetch', 'searchAuthor']),
    actionFetchAuthor() {
      const payload = {
        page: this.currentPage,
        limit: this.perPage,
      }
      this.fetch(payload);
    },
    actionSearchAuthor() {
      const payload = {
        q:this.author_search,
        page: this.currentPage = 1,
        limit: this.perPage,
      }
      this.fetch(payload);
    },
    onSearch(q) {
      const search = q.target.value;
      this.author_search = search;
      if (!search) {
        this.actionFetchAuthor();
        clearTimeout(this.debounce);
        return;
      }
      this.typing = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = false;
        this.actionSearchAuthor();
      }, 600);
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss')
      };
    },
    sortBy(sortByCreate) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      let payload = {
        q:this.author_search,
        page: this.currentPage,
        limit: this.perPage,
        order_by:sortByCreate,
        sort:this.sortOrder
      };
      this.debounce = setTimeout(() => {
        this.fetch(payload)
      }, 600);
    },
    actionReset() {
      this.author_search=''
      this.currentPage = 1
      this.actionFetchAuthor()
    },
    reloadPage() {
      if (!this.author_search) this.actionFetchAuthor();
      else this.actionSearchAuthor();
    },
    onClickPage(page) {
      this.currentPage = page;
      this.reloadPage();
    },
  },
  filters: {
    toLocalStringID(data = 0) {
      return data.toLocaleString('id');
    }
  }
};
</script>

<style scoped>

</style>
